<adapt-dialog [maxWidth]="1000"
              [fitHeight]="isTwoColumnLayout">
    <h3 adapt-dialog-title>Add team</h3>

    <div adapt-dialog-content
         class="d-flex flex-column flex-lg-row gap-3 h-100">
        <div class="guidance-column"
             adaptCollapsible="addTeamDialog">
            <dx-scroll-view>

                <div class="d-flex flex-column">
                    <p>Provide the following details to create the team:</p>
                    <ul>
                        <li>Team name &ndash; clear, concise, and descriptive</li>
                        <li>Team leader &ndash; the person who will lead and facilitate</li>
                        <li>Locations &ndash; where the team operates (optional)</li>
                    </ul>
                </div>
                <div class="d-flex flex-column">
                    <h3>Private team</h3>
                    <p>
                        A private team restricts access to only those who are members of the team and coaches.<br />
                        This includes restricting access to organisation leaders if they are not part of the team.
                    </p>
                </div>
                @if (canCreateOwnerTeam) {
                    <div class="d-flex flex-column">
                        <h3>Owner team</h3>
                        <ul>
                            <li>These are the people who have actual ownership/shares in the business</li>
                            <li>They invest capital and take financial risk in the business</li>
                            <li>They make decisions about major capital investments and business direction</li>
                        </ul>
                    </div>
                }
                @if (canCreateLeadersTeam) {
                    <div class="d-flex flex-column">
                        <h3>Organisation leaders team</h3>
                        <ul>
                            <li>These are the strategic leaders, and typically includes key functions like Operations, Finance,
                                Sales, etc</li>
                            <li>Responsible for implementing strategy and managing teams</li>
                            <li>Their focus is on executing business strategy and achieving operational goals</li>
                        </ul>
                    </div>
                }
            </dx-scroll-view>
        </div>
        <div class="content-column">
            <!-- name -->
            <div>
                <label for="teamNameLabel">Team name</label>
                <dx-text-box id="teamNameLabel"
                             [adaptValidateEntity]="team"
                             adaptValidateEntityProperty="name"
                             [(value)]="team.name"
                             data-test="team-name-input"></dx-text-box>
            </div>

            <!-- leader -->
            <div>
                <label for="inputTeamLeader">{{teamLeaderLabel}}</label>
                <adapt-select-person id="inputTeamLeader"
                                     [required]="true"
                                     [disabled]="isPrivateNonStakeholderManagerOrCoach"
                                     [userTypes]="allowedUserTypes"
                                     [(person)]="team.teamLeaderPerson"
                                     data-test="team-leader-input"></adapt-select-person>
            </div>

            <div class="d-flex flex-column gap-1">
                <label>Locations</label>
                <p class="mb-1">Select the locations that this team should reside within.</p>
                <div class="border-3 border-secondary border-start ps-2">
                    <adapt-edit-team-locations [team]="team"
                                               (populated)="addEntitiesToConfirm($event)"
                                               (added)="onTeamLocationEntityAdded($event)"></adapt-edit-team-locations>

                </div>
            </div>

            <div class="d-flex flex-column gap-2">
                <label>Team options</label>
                <dx-check-box (valueChange)="onPrivateTeamChanged($any($event))"
                              [value]="team.isPrivate"
                              [disabled]="!team.teamLeaderPerson || isOwnerTeam"
                              text="Set as private team"></dx-check-box>
                @if (canCreateOwnerTeam) {
                    <dx-check-box (valueChange)="onOwnerTeamChanged($any($event))"
                                  [value]="isOwnerTeam"
                                  [disabled]="!team.teamLeaderPerson || isLeaderTeam"
                                  text="Set as owner team"></dx-check-box>
                }

                @if (canCreateLeadersTeam) {
                    <dx-check-box [value]="isLeaderTeam"
                                  (valueChange)="onLeaderTeamChanged($any($event))"
                                  [disabled]="!team.teamLeaderPerson || isOwnerTeam"
                                  text="Set as organisation leaders team"></dx-check-box>
                }
            </div>
            <div class="mt-2 alert alert-info"
                 *ngIf="isPrivateNonStakeholderManagerOrCoach">
                Only team members of a private team and coaches will have access to the team. When creating a private team, the person
                creating the team is automatically set to the team leader.
            </div>
        </div>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="add"
                                   saveText="Create team"
                                   [saveIsDisabled]="entitiesAreUnmodifiedOrInvalid"
                                   [saveBlockingClick]="saveAndClose"
                                   [discardConfirmationInstance]="instance">
    </adapt-standard-dialog-buttons>
</adapt-dialog>
